import axios from "@/utils/axios";

enum Api {
  insert = "/wxapi/wechat/leaveApply/add",
  queryList = "/wxapi/wechat/leaveApply/list",
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace Leave {
  export interface insertForm {
    beginTime: string;
    endTime: string;
    reason: string;
    attachment?: string | undefined;
  }
  export interface listQueryParams {
    pageNum: string | number;
    pageSize: string | number;
    leaveDate?: string | undefined;
  }
}

// 查询请假列表
export const getLeaveList = (params: Leave.listQueryParams) => {
  return axios.get(Api.queryList, params);
};

// 新增
export const insertLeave = (params: Leave.insertForm) => {
  return axios.post(Api.insert, params);
};
